import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "text", "className", "iconName"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Button as SemanticUiButton } from 'semantic-ui-react';
import { classNames } from '../../../../../../utils/classname';
import Icon from '../../../../../foundation/components/Icon';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import './MoreInfoButton.css';
var defaultProps = {
  className: '',
  iconName: 'info circle'
};
export default function MoreInfoButton(_ref) {
  var onClick = _ref.onClick,
    text = _ref.text,
    className = _ref.className,
    iconName = _ref.iconName,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!onClick) {
    return null;
  }
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  var finalClassName = classNames(_defineProperty({
    'more-info-button': true
  }, className, true));
  return /*#__PURE__*/React.createElement(SemanticUiButton, _extends({
    className: finalClassName,
    "aria-label": "More Info"
  }, getButtonProps(_objectSpread({
    content: text,
    onClick: onClick
  }, rest)), {
    icon: true
  }), /*#__PURE__*/React.createElement(Icon, {
    iconName: iconName
  }));
}
MoreInfoButton.defaultProps = defaultProps;